import { Badge } from '@/components/ui/badge'
import { DebtLabel, PriceLabel } from '@/components/features/shared/utils'
import { UserRole } from '@/domain/auth/auth'
import { useAuthStore } from '@/store/useAuthStore'

interface OutstandingAmountProps {
  balance: number | undefined
  available: boolean
}

export const OutstandingAmount = ({ balance, available }: OutstandingAmountProps) => {
  const { hasAnyRole } = useAuthStore()
  const isEmployee = hasAnyRole([UserRole.Employee])

  if (!available) {
    return <span className="text-muted-foreground italic text-xs">-</span>
  }

  if (isEmployee) {
    const hasDebt = Math.abs(balance ?? 0) > 0
    return (
      <Badge variant={hasDebt ? 'destructive' : 'secondary'} className="font-bold w-[max-content]">
        {hasDebt ? 'Con Deuda' : 'Sin Deuda'}
      </Badge>
    )
  }

  if (balance === undefined) return '-'

  const isNegative = balance < 0
  return isNegative ? <DebtLabel amount={balance} /> : <PriceLabel price={balance} />
}
